import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sellsy" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sellsy" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel-o" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_9 = {
  filter: "name",
  sort: "name"
}
const _hoisted_10 = {
  filter: "username",
  sort: "username"
}
const _hoisted_11 = {
  filter: "referralCode",
  sort: "referralCode"
}
const _hoisted_12 = {
  filter: "reteGestioneParent",
  sort: "reteGestioneParent.name"
}
const _hoisted_13 = {
  filter: "reteCommercialeParent",
  sort: "reteCommercialeParent.name"
}
const _hoisted_14 = {
  filter: "loginEnabled",
  filterType: "checkbox",
  sort: "loginEnabled"
}
const _hoisted_15 = {
  filter: "role",
  sort: "role"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { colspan: "99" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_24 = ["href"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Elimina", -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Collaboratori",
          text: "Collaboratori"
        })
      ]),
      _createElementVNode("div", null, [
        (_ctx.$store.state.isAdmin())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary ml-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportDashboardMensili && _ctx.exportDashboardMensili(...args)))
            }, [
              _hoisted_2,
              _hoisted_3,
              _createVNode(_component_localized_text, {
                localizedKey: "Esporta dashboard mensili",
                text: "Esporta dashboard mensili"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isAdmin())
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary ml-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportDashboard && _ctx.exportDashboard(...args)))
            }, [
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_localized_text, {
                localizedKey: "Esporta dashboard",
                text: "Esporta dashboard"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isAdmin())
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-primary ml-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
            }, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.$store.state.isAdmin())
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              class: "btn btn-primary ml-2",
              to: "/utenze/detail/0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nuovo utente",
                  text: "Nuovo utente"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.listaUtenze,
      filtersFn: _ctx.filtersFn
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Username",
                text: "Username"
              })
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_localized_text, {
                localizedKey: "ReferralCode",
                text: "ReferralCode"
              })
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "Upliner Gestione",
                text: "Upliner Gestione"
              })
            ]),
            _createElementVNode("td", _hoisted_13, [
              _createVNode(_component_localized_text, {
                localizedKey: "Upliner Commerciale",
                text: "Upliner Commerciale"
              })
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Accesso abilitato",
                text: "Accesso abilitato"
              })
            ]),
            _createElementVNode("td", _hoisted_15, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ruolo",
                text: "Ruolo"
              })
            ]),
            _hoisted_16
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", _hoisted_18, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.username), 1),
              _createElementVNode("td", null, _toDisplayString(item.referralCode), 1),
              _createElementVNode("td", null, _toDisplayString(item.reteGestioneParent ? item.reteGestioneParent.name : ''), 1),
              _createElementVNode("td", null, _toDisplayString(item.reteCommercialeParent ? item.reteCommercialeParent.name : ''), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(item.loginEnabled ? "SI" : "NO"), 1),
              _createElementVNode("td", null, _toDisplayString(item.role), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: "pointer text-link",
                  onClick: ($event: any) => (_ctx.reportFineMese(item))
                }, "Report fine mese", 8, _hoisted_20),
                _hoisted_21,
                _createElementVNode("a", {
                  href: '#/utenze/detail/' + item.identifier
                }, "Modifica", 8, _hoisted_22),
                _hoisted_23,
                _createElementVNode("a", {
                  href: '#/dashboard/' + item.identifier
                }, "Dashboard", 8, _hoisted_24),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link",
                  onClick: ($event: any) => (_ctx.removeItem(item))
                }, _hoisted_27, 8, _hoisted_25)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items", "filtersFn"])
  ]))
}